import React from 'react';
import { FooterText } from '../FooterText';

const FooterAuth = () => (
    <div>
        <p className="small text-muted">
            <FooterText />
        </p>
    </div>
)

export { FooterAuth };
